// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-top-total_table .b-table .table th{padding:.5rem}.card-top-total_table .b-table .table td{padding:1rem .5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
